export const RETRY_DELAY_MS = 250;

const CONNECTION_ERROR_NAMES = new Set(['AbortError', 'UnknownError', 'InvalidStateError', 'TransactionInactiveError']);

const CONNECTION_ERROR_PATTERN = /closing|lost|abort|inactive/i;

export function isQuotaExceededError(e: unknown): boolean {
  return (e as DOMException)?.name === 'QuotaExceededError';
}

export function isConnectionError(e: unknown): boolean {
  if (isQuotaExceededError(e)) {
    return false;
  }
  const name = (e as DOMException)?.name ?? '';
  const message = (e as Error)?.message ?? (typeof e === 'string' ? e : '');
  return CONNECTION_ERROR_NAMES.has(name) || CONNECTION_ERROR_PATTERN.test(message);
}

export type PersistenceStatus = 'pending' | 'saved' | 'failed';

export interface PersistenceFailure {
  storeName: string;
  operation: string;
  error: unknown;
  attempts: number;
  happenedAt: string;
}

export type PersistenceFailureHandler = (failure: PersistenceFailure) => void | Promise<void>;

export function createMemoryRecoveryQueue(limit = 200): {
  enqueue(failure: PersistenceFailure): void;
  entries(): PersistenceFailure[];
  droppedCount(): number;
} {
  const buffered: PersistenceFailure[] = [];
  let dropped = 0;
  return {
    enqueue(failure: PersistenceFailure): void {
      if (buffered.length >= limit) {
        buffered.shift();
        dropped += 1;
      }
      buffered.push(failure);
    },
    entries(): PersistenceFailure[] {
      return [...buffered];
    },
    droppedCount(): number {
      return dropped;
    },
  };
}
